import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu as MenuIcon, Phone, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { telLink } from "@/lib/api";
import { Logo } from "./Primitives";

const LINKS = [
  { href: "/#lezzetler", label: "Lezzetler", id: "nav-flavors-link" },
  { href: "/menu", label: "Menü", id: "nav-menu-link" },
  { href: "/#hikayemiz", label: "Hikayemiz", id: "nav-about-link" },
  { href: "/#galeri", label: "Galeri", id: "nav-gallery-link" },
  { href: "/#iletisim", label: "İletişim", id: "nav-contact-link" },
];

export function Header() {
  const { settings } = useSite();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="fixed inset-x-0 top-0 z-40" data-testid="site-header">
      {settings.announcement_active && settings.announcement && (
        <div className="bg-[#C84B31] text-[#FDFBF7] text-xs sm:text-[13px] text-center py-2 px-4 tracking-wide" data-testid="announcement-bar">
          {settings.announcement}
        </div>
      )}
      <div
        className={`transition-[background-color,backdrop-filter,border-color] duration-500 border-b ${
          scrolled || open ? "bg-[#140D0B]/85 backdrop-blur-xl border-[#D4AF37]/20" : "bg-transparent border-transparent"
        }`}
      >
        <div className="mx-auto max-w-7xl px-5 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link">
            <Logo size={46} className="transition-transform duration-500 group-hover:rotate-[8deg]" />
            <span className="hidden sm:block leading-none">
              <span className="block font-display text-[10px] tracking-[0.4em] text-[#D4AF37]">YENİ</span>
              <span className="block font-display text-lg tracking-[0.12em] text-[#FDFBF7]">MERCAN</span>
            </span>
          </Link>
          <nav className="hidden lg:flex items-center gap-9">
            {LINKS.map((l) => (
              <a key={l.id} href={l.href} data-testid={l.id} className="text-sm text-[#CBBBAE] hover:text-[#D4AF37] transition-colors duration-300 tracking-wide">
                {l.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <a href={telLink(settings.phone)} className="hidden md:inline-flex items-center gap-2 text-sm text-[#FDFBF7] hover:text-[#D4AF37] transition-colors" data-testid="nav-phone-link">
              <Phone size={15} className="text-[#D4AF37]" /> {settings.phone}
            </a>
            <a href="/#rezervasyon" className="btn-gold !px-5 !py-2.5 hidden sm:inline-flex" data-testid="nav-reservation-btn">
              Rezervasyon
            </a>
            <button
              className="lg:hidden text-[#FDFBF7] p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menüyü aç"
              data-testid="nav-mobile-toggle"
            >
              {open ? <X /> : <MenuIcon />}
            </button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-[#D4AF37]/15 px-5 pb-6 pt-2" data-testid="nav-mobile-panel">
            {LINKS.map((l) => (
              <a key={l.id} href={l.href} onClick={() => setOpen(false)} data-testid={`mobile-${l.id}`} className="block py-3 font-serif-ym text-2xl text-[#FDFBF7] border-b border-white/5">
                {l.label}
              </a>
            ))}
            <a href="/#rezervasyon" onClick={() => setOpen(false)} className="btn-gold w-full mt-5" data-testid="mobile-nav-reservation-btn">
              Rezervasyon Yap
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
